import React from "react";

export const About = () => {
  return (
    <div className="about">
      <h4 className="about-title">About</h4>
      <p className="content">
        I am a Front End developer with industry experience building websites
        and web applications. I specialize in JavaScript and have professional
        experience working with HTML, CSS, React.
      </p>
    </div>
  );
};
